import { render, staticRenderFns } from "./AudioPlayerComponent.vue?vue&type=template&id=cab8127c&"
import script from "./AudioPlayerComponent.vue?vue&type=script&lang=js&"
export * from "./AudioPlayerComponent.vue?vue&type=script&lang=js&"
import style0 from "./AudioPlayerComponent.vue?vue&type=style&index=0&id=cab8127c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports